import { makeReverseTComposable } from "@saflib/vue";
import { power_up_app_strings } from "./strings.ts";

export const { useReverseT } = makeReverseTComposable(power_up_app_strings);
